<ng-container *mobxAutorun="{ detach: true }">
  <page-title
    class="ion-margin-top"
    [title]="
      'components.performance.titles.' + (contextOwner ? 'contextTitle' : 'title')
        | translate: { name: contextOwner?.name }
    "
    icon="pie-chart"
    *ngIf="showHeader"
  >
    <span class="flex"></span>
    <ion-item class="period-select">
      <ion-col>
        <ion-label>
          {{ 'components.leaderboard.inputs.dateLabel' | translate }}
        </ion-label>
        <ion-select
          [value]="period"
          (ionChange)="getPerformanceData($any($event).detail.value)"
          [interfaceOptions]="{
            size: 'auto',
            alignment: 'start'
          }"
        >
          <ion-select-option [value]="option" *ngFor="let option of periodOptions">
            {{ 'components.leaderboard.inputs.periodValue' | translate: { value: option } }}
          </ion-select-option>
        </ion-select>
      </ion-col>
    </ion-item>
  </page-title>

  <ion-col id="performance" class="ion-no-padding">
    <div class="ion-margin-top performance-cards">
      <article
        [class.analyze]="analyze"
        *ngFor="let group of $any(!loading ? data : [{}, {}, {}, {}, {}, {}, {}])"
        [joyrideStep]="group.name || 'loading'"
        [title]="'components.performance.tour.' + group.name + '.title' | translate"
        [text]="'components.performance.tour.' + group.name + '.body' | translate"
      >
        <ng-container *ngIf="loading">
          <h2 class="ion-margin-horizontal" [class.md-border-bottom]="compact">
            <ion-skeleton-text animated></ion-skeleton-text>
          </h2>
          <div class="stats">
            <h2 class="ion-margin-horizontal">
              <ion-skeleton-text animated></ion-skeleton-text>
            </h2>
            <!-- <ion-progress-bar color="success" value="0.5"></ion-progress-bar> -->
            <h2 class="positive" class="ion-margin-horizontal">
              <ion-skeleton-text animated></ion-skeleton-text>
            </h2>
          </div>
          <p class="ion-margin-horizontal" *ngIf="showPeriod">
            <ion-skeleton-text animated></ion-skeleton-text>
          </p>
        </ng-container>

        <ng-container *ngIf="!loading">
          <div *ngIf="!analyze">
            <!-- dashboard grid -->
            <h2
              [class.md-border-bottom]="compact"
              class="ly-row ion-align-items-center ion-justify-content-center"
            >
              {{
                'components.performance.headers.' + group.name | translate: { value: this.period }
              }}
              <ng-container *ngIf="group.name === 'value'">
                &nbsp;
                <div
                  [tooltip]="$any(tooltipContent)"
                  contentType="template"
                  [options]="{
                    'tooltip-class': 'earned-value-tooltip'
                  }"
                >
                  <ion-icon
                    *ngIf="isDesktop"
                    name="information-circle-outline"
                    style="pointer-events: none"
                  >
                  </ion-icon>
                </div>
              </ng-container>
            </h2>

            <ng-container *ngFor="let stat of group.stats; let i = index">
              <h6 *ngIf="group.stats?.length === 2">
                {{ stat.name | translate }}
              </h6>
              <div class="stats">
                <h3>{{ stat.current }}</h3>
                <ng-container *ngIf="stat.indication === 'positive'">
                  <!-- <ion-progress-bar color="success" value="0.5"></ion-progress-bar> -->
                  <h2 class="positive"><ion-icon name="arrow-up"></ion-icon> {{ stat.change }}</h2>
                </ng-container>
                <ng-container *ngIf="stat.indication === 'negative'">
                  <!-- <ion-progress-bar color="danger" value="0.5"></ion-progress-bar> -->
                  <h2 class="negative">
                    <ion-icon name="arrow-down"></ion-icon> {{ stat.change }}
                  </h2>
                </ng-container>
              </div>
              <div *ngIf="group.stats?.length === 2 && i === 0" class="md-border-bottom"></div>
            </ng-container>

            <p *ngIf="showPeriod">
              vs
              {{ 'components.leaderboard.inputs.periodValue' | translate: { value: this.period } }}
            </p>
          </div>
          <div *ngIf="analyze">
            <!-- analytics grid -->
            <h2 class="analyze" [class.md-border-bottom]="compact">
              {{
                'components.performance.headers.' + group.name | translate: { value: this.period }
              }}
              <ng-container *ngIf="group.name === 'value'">
                &nbsp;
                <div
                  [tooltip]="$any(tooltipContent)"
                  contentType="template"
                  [options]="{ 'tooltip-class': 'earned-value-tooltip' }"
                >
                  <ion-icon
                    *ngIf="isDesktop"
                    name="information-circle-outline"
                    style="pointer-events: none; padding-top: 2px"
                  >
                  </ion-icon>
                </div>
              </ng-container>
            </h2>

            <ng-container *ngFor="let stat of group.stats; let i = index">
              <div class="analyzeContainer">
                <div class="indicator">
                  <h6 *ngIf="group.stats?.length === 2" class="comparison">
                    {{ stat.name | translate }}
                  </h6>
                  <h2 *ngIf="stat.indication === 'positive'" class="positive">
                    <ion-icon name="arrow-up"></ion-icon> {{ stat.change }}
                  </h2>
                  <h2 *ngIf="stat.indication === 'negative'" class="negative">
                    <ion-icon name="arrow-down"></ion-icon> {{ stat.change }}
                  </h2>
                </div>
                <div>
                  <h6>CURRENT</h6>
                  <div class="stats">
                    <h3>{{ stat.current }}</h3>
                  </div>
                  <hr />
                  <h6>PREVIOUS</h6>
                  <div class="stats">
                    <h3>{{ stat.previous }}</h3>
                  </div>
                  <div *ngIf="group.stats?.length === 2 && i === 0" class="md-border-bottom"></div>
                </div>
              </div>
            </ng-container>

            <p *ngIf="showPeriod">
              vs
              {{ 'components.leaderboard.inputs.periodValue' | translate: { value: this.period } }}
            </p>
          </div>
        </ng-container>
      </article>
    </div>
  </ion-col>
  <ng-template #tooltipContent>
    <earned-value-info></earned-value-info>
  </ng-template>
</ng-container>
